import React, {Component} from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import { Dates } from '../../../../packages/dates';
import EpgPersistence from '../../../../AAF/Nepg/EpgPersistence';
import Utils from '../../../../utils/Utils';

class CardLiveChannel extends Component{
  constructor(props) {
    super(props);
    this.state = {
      showActions: props.showActions
    };
    this.hasPlayerIcon = props.hasPlayerIcon;
    this.cover = props.cover;
    this.bookmark = props.bookmark;
    this.title = props.title;
    this.onDeleteAction = props.onDeleteAction;
    this.data = props.data;
    this.badges = props.badges;
    this.id = props.id;
  }

  componentWillUpdate(nextProps){
    if(nextProps.showActions !== this.state.showActions){
      this.setState({showActions: nextProps.showActions});
    }
  }

  

  render() {
    const dateStart = EpgPersistence.needsOffset() ? new Dates().unix(this.data.unix_begin).utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm') : new Dates().unix(this.data.unix_begin).format('HH:mm');
    const dateEnd = EpgPersistence.needsOffset() ? new Dates().unix(this.data.unix_end).utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm') : new Dates().unix(this.data.unix_end).format('HH:mm');
    const pgress = CardHelper.getTimeProgress(this.data.unix_begin, this.data.unix_end);
    const {channelNumber = '', channelName = '', title} = this.data || {};
    const titleChannel =  `${CardHelper.fillZeroLeft(channelNumber, 4)} | ${channelName}`;
    const size = 22;
    const sizeTitle = 21;
    const titleFinalChannel = (typeof titleChannel === 'string') ?  (titleChannel.length > size  ? Utils.cutPlayerString(titleChannel, size)   : titleChannel) : titleChannel;
    const finalTitle = (typeof title === 'string') ?  (title.length > sizeTitle  ? Utils.cutPlayerString(title, sizeTitle)   : title) : title;

    return (
      <div className={'card card-livechannel'}>
        <div className={'card-container'}>
          {this.cover !== '' &&
          <div
            className='card-cover'
            style={{backgroundImage: `url(${this.data.cover})`, backgroundPosition: 'center'}}
          />
          }
          {CardHelper.createProgressBar(pgress, this.hasPlayerIcon)}
          {CardHelper.createBadge(this.badges)}
          {CardHelper.createPlayerIcon()}
        </div>
        <div className={'card-info'}>
          <div className={'card-info_container'}>
            <p className={'title'}>{finalTitle}</p>
            <p className={'description'}>{titleFinalChannel}</p>
            <p className={'status'}>
              <i className="fa fa-television" aria-hidden="true"></i>
              <span className="badge badge-color">
           EN VIVO
          </span>
            </p>
            <p className={'time'}>{dateStart} - {dateEnd} {this.state.showActions && CardHelper.createDeleteIcon()}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default CardLiveChannel;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardLiveChannel/index.js